/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20013DataStudentSignedPermission model module.
 * @module model/InlineResponse20013DataStudentSignedPermission
 * @version 1.0.0
 */
class InlineResponse20013DataStudentSignedPermission {
    /**
     * Constructs a new <code>InlineResponse20013DataStudentSignedPermission</code>.
     * @alias module:model/InlineResponse20013DataStudentSignedPermission
     */
    constructor() { 
        
        InlineResponse20013DataStudentSignedPermission.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20013DataStudentSignedPermission</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20013DataStudentSignedPermission} obj Optional instance to populate.
     * @return {module:model/InlineResponse20013DataStudentSignedPermission} The populated <code>InlineResponse20013DataStudentSignedPermission</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20013DataStudentSignedPermission();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('permission')) {
                obj['permission'] = ApiClient.convertToType(data['permission'], 'String');
            }
            if (data.hasOwnProperty('date_permission')) {
                obj['date_permission'] = ApiClient.convertToType(data['date_permission'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20013DataStudentSignedPermission.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
InlineResponse20013DataStudentSignedPermission.prototype['student_id'] = undefined;

/**
 * @member {String} permission
 */
InlineResponse20013DataStudentSignedPermission.prototype['permission'] = undefined;

/**
 * @member {String} date_permission
 */
InlineResponse20013DataStudentSignedPermission.prototype['date_permission'] = undefined;






export default InlineResponse20013DataStudentSignedPermission;

